import Router from 'vue-router'
import store from './store'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo)

Vue.use(Router)
const Empty = {
    template: '<div></div>'
}
const routes = [
    {
        path: '/',
        beforeEnter: (to, from, next) => {
            store.dispatch('setActiveTab', 'personalia')
            setTimeout(function () {
                VueScrollTo.scrollTo('#personalia', 500, {offset: -90})
            }, 400)
            next()
        }
    },
    {
        path: '/personalia',
        beforeEnter: (to, from, next) => {
            store.dispatch('setActiveTab', 'personalia')
            setTimeout(function () {
                VueScrollTo.scrollTo('#personalia', 500, {offset: -90})
            }, 400)
            next()
        }
    },
    {
        path: '/looks',
        beforeEnter: (to, from, next) => {
            store.dispatch('setActiveTab', 'looks')
            setTimeout(function () {
                VueScrollTo.scrollTo('#looks', 500, {offset: -90})
            }, 400)
            next()
        }
    },
    {
        path: '/misc',
        beforeEnter: (to, from, next) => {
            store.dispatch('setActiveTab', 'misc')
            setTimeout(function () {
                VueScrollTo.scrollTo('#misc', 500, {offset: -90})
            }, 400)
            next()
        }
    },
    {
        path: '/photos',
        beforeEnter: (to, from, next) => {
            store.dispatch('setActiveTab', 'photos')
            setTimeout(function () {
                VueScrollTo.scrollTo('#photos', 500, {offset: -90})
            }, 400)
            next()
        }
    },
    {
        path: '/finish',
        beforeEnter: (to, from, next) => {
            store.dispatch('setActiveTab', 'finish')
            next()
        }
    },
    {
        path: '/', props: true, component: Empty
    }
]


const router = new Router({
    mode: 'history',
    routes,

})
export default router
